import { lazyLoad } from 'utils/lazy';

export const Staff = lazyLoad(
  () => import('./Staff'),
  (m) => m.Staff
);
